/**
 * Initializes the main Swiper for social proof with autoplay progress tracking.
 * Adjusts the width of the progress bar based on the remaining autoplay time.
 */
const swiperMain = () => {
  // Selects the main Swiper container with the class `social-proof-main`.
  const swiperEl = document.querySelector('swiper-container.social-proof-main');
  if (!swiperEl) return;

  // Selects the progress bar element within the `social-proof-main` container.
  const progressBar = document.querySelector("swiper-container.social-proof-main .autoplay-progress .progress-bar");
  if (!progressBar) return;

  // Defines Swiper parameters, including an autoplay event handler for updating the progress bar.
  const swiperParams = {
    on: {
      autoplayTimeLeft(s, time, progress) {
        // Sets the width of the progress bar according to the remaining autoplay time.
        progressBar.style.width = `${(1 - progress) * 100}%`;
      }
    }
  };

  // Merges custom Swiper parameters into the Swiper element and initializes it.
  Object.assign(swiperEl, swiperParams);
  swiperEl.initialize();
};

/**
 * Initializes the thumbnail Swiper for social proof with responsive configurations.
 * Calls the main Swiper initialization after setting up the thumbnail Swiper.
 */
const swiperThumbnail = () => {
  // Selects the thumbnail Swiper container with the class `social-proof-thumbnail`.
  const swiperEl = document.querySelector('swiper-container.social-proof-thumbnail');
  if (!swiperEl) return;

  // Defines Swiper parameters for the thumbnail view with responsive breakpoints.
  const swiperParams = {
    slidesPerView: 2,
    spaceBetween: 0,
    breakpoints: {
      992: {
        spaceBetween: 40,
        slidesPerView: 7
      }
    }
  };

  // Merges custom Swiper parameters into the Swiper element and initializes it.
  Object.assign(swiperEl, swiperParams);
  swiperEl.initialize();

  // Initializes the main Swiper after setting up the thumbnail Swiper.
  swiperMain();
};

/**
 * Initializes the social proof Swiper components by setting up the thumbnail Swiper.
 */
const initSocialProof = () => {
  swiperThumbnail();
};

export default initSocialProof;
